import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const LegalsRoutes = defineRoute({
    record: {
        route: {
            path: "/legals",
            component: () => loadView(import("./LegalsTable.vue")),
        },
    },
    create: {
        route: {
            path: "/legals/create",
            component: () => loadView(import("./LegalsCreate.vue")),
        },
    },
    detail: {
        route: {
            path: "/legals/:id",
            component: () => loadView(import("./LegalsDetail.vue")),
        },
        build(id: string) {
            return `/legals/${id}`;
        },
    },
});
